import AvailabilityAction from '~/constants/availabilityAction';
import { useVehicleAvailability } from '~/context/vdp/UserVehicleContext';

export default function useGetStartedText(
  hasExpiredFinancing: boolean = false
): string {
  const { action } = useVehicleAvailability();

  switch (action) {
    case AvailabilityAction.GetStarted:
      return hasExpiredFinancing
        ? 'Purchase Without Financing'
        : 'Start Your Purchase';
    case AvailabilityAction.PreOrderNow:
      return 'Pre-Order Now';
    default:
      return '';
  }
}
